var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.setupStateText !== ""
    ? _c("span", { staticClass: "badge", class: _vm.setupCssClass }, [
        _vm._v(_vm._s(_vm.$t("support.setupState." + _vm.setupStateText)))
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1745b5f4", { render: render, staticRenderFns: staticRenderFns })
  }
}